import React from 'react'
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { navigate } from '@reach/router'
import isotipo from 'assets/images/Isotipo.svg'
import images from 'assets/images/logo-pichincha.png'
import { Subject } from 'rxjs'
import { take } from 'rxjs/operators'
import { capital_letter } from 'utils'
import './header.css'
import { KeyboardArrowLeft, LockOutlined } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { RootState } from 'context';
import { AppState } from 'interfaces/app';
const button$ = new Subject()

const Header: React.FC = () => {
  const { login } = useSelector<RootState, AppState>(state => state.app)
  const isSolicitude = window.location.pathname.includes('/solicitud')

  React.useEffect(() => {
    const subscription = button$.pipe(take(1)).subscribe(() => {
      navigate('https://bancopichincha.optimalworkshop.com/questions/n27s1687')
    })
    return () => subscription.unsubscribe()
  }, [])

  return (
    <header id="header" className="header">
      <Container maxWidth="lg" className="h-100">
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          className="h-100"
        >
          <Grid container className="w-20">
            {!isSolicitude && (
              <Grid
                item
                className="icon-back"
                id="btnReturn"
                data-testid="btnReturn"
                onClick={() => window.history.back()}
              >
                <KeyboardArrowLeft style={{ fontSize: 32 }} />
              </Grid>
            )}
            <Grid item className="vertical-center">
              <img
                src={document.body.clientWidth <= 320 ? isotipo : images}
                id="logo"
                alt="logo"
                className={`imgLogo ${!isSolicitude ? 'invisibleMovil' : ''}`}
              />
            </Grid>
          </Grid>
          <Grid item xs="auto">
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="flex-end"
            >
              <Grid
                item
                className="fullNameContainer bp-mb-4"
                id="NameComplete"
              >
                <pichincha-typography variant="tinyText" id="nameClient">
                  {capital_letter(login.fullName)}
                </pichincha-typography>
                <LockOutlined className="iconLock" fontSize="inherit" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </header>
  )
}

export default Header
